import React from 'react';
import SectionHeading from '../../../Components/Shared/SectionHeading';
// import Swiper core and required modules
import { Navigation, A11y, EffectFade, Autoplay } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';



// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

//brand img 
import brand from '../../../Assert/PopularBrands/brand01.jpg'

const PopularBrands = () => {
    // const swiper = new Swiper()
    return (
        <div className='hidden md:block'>
            <SectionHeading text={"Popular Brands"} />



            <div className="">
                <Swiper
                    loop={true}
                    spaceBetween={30}

                    autoplay={{
                        delay: 1000
                    }}
                    modules={[Autoplay, A11y, EffectFade, Navigation]}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 50,
                        },
                    }}
                    navigation={{
                        prevEl: '.prev',
                        nextEl: '.next',
                    }}
                    className="mySwiper"
                >
                    <div className="relative">
                        <button className='prev text-black absolute top-0 left-0 btn btn-primary'>prev</button>
                        <button className='next'>next</button>
                        {Array.from({ length: 21 }).map((_, id) =>
                            <SwiperSlide key={id}>
                                <img className=' w-40 h-32' src={brand} alt="" />
                            </SwiperSlide>
                        )}

                    </div>

                </Swiper>
            </div>



        </div>
    );
};

export default PopularBrands;